const LS_KEY = 'salidas_pendientes';
const LS_SIN_EXISTENCIAS = 'salidas_sin_existencias';

class SalidasLocalService {
  static _nextId = 0;

  static _generarId() {
    this._nextId -= 1;
    return this._nextId;
  }

  static _normalizar(value) {
    return String(value ?? '').trim().toUpperCase();
  }

  static _normalizarMedida(value) {
    const n = Number(value);
    return Number.isFinite(n) ? String(n) : String(value ?? '').trim().toUpperCase();
  }

  static _mismaPartida(a, b) {
    return (
      this._normalizar(a.clavearticulo) === this._normalizar(b.clavearticulo) &&
      this._normalizarMedida(a.medida) === this._normalizarMedida(b.medida) &&
      this._normalizar(a.almacenexhibidor) === this._normalizar(b.almacenexhibidor)
    );
  }

  static cargar() {
    try {
      const stored = localStorage.getItem(LS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  static guardar(items) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(items));
    } catch {}
  }

  static agregarArticulo(partida) {
    try {
      if (!partida) return null;
      const items = this.cargar();
      const existingIndex = items.findIndex((item) => this._mismaPartida(item, partida));

      if (existingIndex >= 0) {
        const existing = items[existingIndex];
        const cantidadSumada = (Number(existing.cantidadarticulo) || 0) + (Number(partida.cantidadarticulo) || 0);
        items[existingIndex] = {
          ...existing,
          codigobarras: existing.codigobarras || partida.codigobarras || partida.codigoBarras || '',
          cantidadarticulo: cantidadSumada,
        };
      } else {
        const item = { ...partida };
        if (item.id === undefined || item.id === null) {
          item.id = this._generarId();
        }
        items.push(item);
      }

      localStorage.setItem(LS_KEY, JSON.stringify(items));
      return items;
    } catch {
      return null;
    }
  }

  static actualizarCantidad(id, nuevaCantidad) {
    try {
      const items = this.cargar();
      const index = items.findIndex((item) => item.id === id || item._localId === id);
      if (index < 0) return false;
      items[index] = { ...items[index], cantidadarticulo: nuevaCantidad };
      localStorage.setItem(LS_KEY, JSON.stringify(items));
      return true;
    } catch {
      return false;
    }
  }

  static eliminarPartida(id) {
    try {
      const items = this.cargar().filter((item) => item.id !== id && item._localId !== id);
      localStorage.setItem(LS_KEY, JSON.stringify(items));
      return items;
    } catch {
      return [];
    }
  }

  static limpiar() {
    try {
      localStorage.removeItem(LS_KEY);
    } catch {}
  }

  static obtenerCantidadAcumulada(clavearticulo, medida, almacenexhibidor) {
    try {
      const items = this.cargar();
      return items
        .filter(
          (item) =>
            item.clavearticulo === clavearticulo &&
            item.medida === medida &&
            item.almacenexhibidor === almacenexhibidor
        )
        .reduce((sum, item) => sum + (Number(item.cantidadarticulo) || 0), 0);
    } catch {
      return 0;
    }
  }

  static obtenerPartidaPorCodigoBarras(codigobarras, almacenexhibidor) {
    try {
      const codigo = this._normalizar(codigobarras);
      const almacen = this._normalizar(almacenexhibidor);
      if (!codigo) return null;
      return this.cargar().find(item =>
        this._normalizar(item.codigobarras || item.codigoBarras) === codigo &&
        (!almacen || this._normalizar(item.almacenexhibidor) === almacen)
      ) || null;
    } catch {
      return null;
    }
  }

  static cargarSinExistencias() {
    try {
      const stored = localStorage.getItem(LS_SIN_EXISTENCIAS);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  static guardarSinExistencias(items) {
    try {
      localStorage.setItem(LS_SIN_EXISTENCIAS, JSON.stringify(items));
    } catch {}
  }

  static agregarSinExistencias(item) {
    try {
      const items = this.cargarSinExistencias();
      items.push(item);
      localStorage.setItem(LS_SIN_EXISTENCIAS, JSON.stringify(items));
    } catch {}
  }

  static limpiarSinExistencias() {
    try {
      localStorage.removeItem(LS_SIN_EXISTENCIAS);
    } catch {}
  }
}

export default SalidasLocalService;
